import { GameVars } from "../../../../GameVars";
import { AudioManager } from "../../../../AudioManager";

export class PointsLayer extends Phaser.GameObjects.Container {

    private points: Phaser.GameObjects.Text;

    private index: number;

    constructor(scene: Phaser.Scene, index: number) {

        super(scene);

        this.index = index;

        this.points = new Phaser.GameObjects.Text(this.scene, 0, 0, "", {fontFamily: "HelveticaNeue", fontSize: "50px", color: "#FFFFFF"});
        this.points.setStroke("#000000", 10);
        this.points.setOrigin(.5);
        this.add(this.points);

        this.visible = false;
    }

    public show(): void {

        AudioManager.playSound("points");
        
        this.visible = true;
        this.alpha = 0;

        let text = GameVars.players[this.index].lastPoints.toString();

        if (GameVars.players[this.index].lastPoints === 0) {
            text = GameVars.gameText.GAME[7];
            this.points.setColor("#e92f43");
        } else {
            this.points.setColor("#ffffff");
        }

        this.points.setText(text);

        this.scene.tweens.add({
            targets: this,
            alpha: 1,
            ease: Phaser.Math.Easing.Cubic.Out,
            duration: 500
        });

        this.scene.tweens.add({
            targets: this,
            alpha: 0,
            ease: Phaser.Math.Easing.Cubic.In,
            delay: 500,
            duration: 500
        });

        this.scene.tweens.add({
            targets: this,
            y: -50,
            ease: Phaser.Math.Easing.Linear.Linear,
            duration: 1000,
            onComplete: () => {
                this.visible = false;
                this.y = 0;
            }, 
            onCompleteScope: this
        });
    }
}
